import * as React from 'react';

import {Dialog} from 'shells/dialog/dialog';

type Props = {
    anchor: HTMLElement | null | undefined;
    onDeleteActivity: (removeSyncedCalendar: boolean) => void;
    onCancel: () => void;
    isReadOnly?: boolean;
    isConnectedToExternalCalendar?: boolean;
};

export function DeleteConfirmationDialog(props: Props) {
    const {onDeleteActivity} = props;

    const canDeleteEverywhere = props.isConnectedToExternalCalendar && !props.isReadOnly;
    // Only mention the external calendar if we can delete everywhere
    const question = canDeleteEverywhere
        ? 'Are you sure you want to delete this activity? It exists both in Nutshell and on an external calendar'
        : 'Are you sure you want to delete this activity?';

    // If we are connected to an external calendar, copy should reflect that
    // we're deleting from Nutshell, not the external calendar (even in a
    // readonly state)
    const primaryText = props.isConnectedToExternalCalendar ? 'Delete from Nutshell' : 'Delete';
    const secondaryText = canDeleteEverywhere ? 'Delete everywhere' : undefined;

    // 400px fits 3 buttons, 250px fits both options with 2 buttons
    const width = canDeleteEverywhere ? '400px' : '250px';

    const onSecondary = React.useCallback(() => onDeleteActivity(true), [onDeleteActivity]);
    const onPrimary = React.useCallback(() => onDeleteActivity(false), [onDeleteActivity]);

    return (
        <Dialog
            anchor={props.anchor}
            location='bottom'
            question={question}
            primaryText={primaryText}
            secondaryText={secondaryText}
            tertiaryText='Cancel'
            onPrimary={onPrimary}
            onSecondary={canDeleteEverywhere ? onSecondary : undefined}
            onTertiary={props.onCancel}
            isWarning={true}
            secondaryVariant='danger'
            tertiaryVariant='secondary'
            customStyles={{width, maxWidth: 'none'}}
        />
    );
}
